import { useEffect, useState } from "react";
import { getCompanyAllRanking } from "../../../../../../api/company-ranking";
import { RankingDto } from "../../../../../../api/runner-ranking";

export const useRabbitFestivalRank = () => {
  const [list, setList] = useState<RankingDto[]>([]);
  const [top3, setTop3] = useState<RankingDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isFirst, setIsFirst] = useState(true);

  const getData = async () => {
    setLoading(true);
    const res = await getCompanyAllRanking(currentPage, 6);

    const customOrder = [2, 1, 3];
    const top3 = res.top3.sort(
      (a, b) => customOrder.indexOf(a.rank) - customOrder.indexOf(b.rank)
    );

    setTop3(top3);

    setList(res.rankings);
    setTotalPages(Math.ceil(res.total / 6));

    setTimeout(() => {
      setLoading(false);
      setIsFirst(false);
    }, 50);
  };

  useEffect(() => {
    getData();
  }, [currentPage]);

  return {
    list,
    top3,
    totalPages,
    currentPage,
    setCurrentPage,
    loading,
    isFirst,
  };
};
